const content = document.getElementById('article-content');
let contentHtml = content.innerHTML;

// Nettoyage des balises [BLOCK]
contentHtml = contentHtml.replace(/(<[^>]*>)*[&nbsp;]*\[BLOCK\](<\/[^>]*>)*/gi, '<div class="article-row"><div class="text-wrapper">');
contentHtml = contentHtml.replace(/(<[^>]*>)*[&nbsp;]*\[\/BLOCK\](<\/[^>]*>)*/gi, '</div></div>');

content.innerHTML = contentHtml;

const articleRows = content.querySelectorAll('.article-row');
articleRows.forEach((articleRow) => {
  const imgWrapper = document.createElement('div');
  imgWrapper.className = 'img-wrapper';

  const textWrapper = document.createElement('div');
  textWrapper.className = 'text-wrapper';

  // Récupération de l'image
  const img = articleRow.querySelector('img');
  imgWrapper.appendChild(img);
  articleRow.appendChild(imgWrapper);
});

const emptyTags = content.querySelectorAll('.article-row p:empty');
emptyTags.forEach((emptyTag) => {
  emptyTag.remove();
})
